import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';

import moment from 'moment';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';
import parse from 'html-react-parser';

import { useQuery } from '@apollo/react-hooks';
import { GET_END } from './queries';
import { IEnd } from '../../../helper/Types';
import Utils from '../../../helper/Utils';

import { VALoading, VALazyImage } from '../../../components';

import useDocTitle from '../../../hooks/useDocTitle';


function ENDDetailContainer() {
    const history = useHistory();
    const params:any = useParams();
    const [current, setCurrent] = useState(1);

    const loadData = useQuery<IEnd>(GET_END, {
        variables: {
            uid: params.uid
        }
    });


    let category = "essay-item";
    let postHeader = (null);
    let postDescription = (null);
    let media = (null);
    let settingsMedia = {
        dot: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        afterChange: (current:number) => {
            setCurrent(current+1)
        },
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    dot: false,
                    arrow: false,
                    rows: 1,
                }
            }
        ]
    };

    const [title, setTitle] = useDocTitle('');    
    useEffect(() => {
        if( !loadData.loading && !loadData.error ) {
            const _data:any = loadData;
            const { post } = _data.data.end;

            setTitle(post.title);
        }
    }, [loadData]);

    
    if( !loadData.loading && !loadData.error ) {
        const _data:any = loadData;
        const { post } = _data.data.end;

        postHeader = (
            <header className="dne-info">
                <time dateTime="" className="date">{moment(Number(post.date)).format("YYYY.MM.DD")}</time>
                <span className="category">{post.end.category}</span>
                <h1 className="title">{post.title}</h1>
                <p className="copyright">
                    {post.end.copyright.split('\n').map( (_item:any, _index:number) => {
                        return(<Fragment key={_index}>{_item}<br/></Fragment>)
                    })}
                </p>
                <span className="current">{current}/{post.media.length}</span>
            </header>
        );

        postDescription = (
            <p className="post-description">
                {Utils.converToBold(post.description).split('\n').map( (_item:any, _index:number) => {
                    return(<Fragment key={_index}>{parse(_item)}<br/></Fragment>)
                })}
            </p>
        )

        category = post.end.category === "essay" ? "essay-item" : "drawing-item";
    
        settingsMedia = {
            ...settingsMedia,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        dot: false,
                        arrow: false,
                        rows: post.media.length,
                    }
                }
            ]
        }

        media = post.media.map((_item:any, _index:number) => {
            if( _item.type === 'photo' ) {
                return(
                    <div key={_index} className="photo">
                        <div className="inner">
                            <img key={_index} src={_item.url} alt="" style={{ display: "block" }} />
                        </div>
                    </div>
                    // <VALazyImage key={_index} src={_item.url} alt="" />
                );
            }
            if( _item.type === 'video' ) {
                return(
                    <div key={_index} className="video">
                        <div className="inner">
                            <ReactPlayer url={_item.url} height='100%' width='100%' controls className="vimeo-player" />
                        </div>
                    </div>
                );
            }
        });
    }

    const _nextUid:String | undefined = loadData.data?.end.nextUid;
    const nextUrl:any = `/about/essay&drawing/${_nextUid}`;
    
    return(
        <article className="layout-contents-container page-details">
            <button type="button" className="btn-back" onClick={history.goBack}>Back</button>

            { loadData.loading && <VALoading data-size="xlarge" /> }
            { loadData.error && <div>에러가 발생했습니다.</div> }

            <div className={category}>
                {postHeader}

                <div className="contents">
                    <Slider className="list-media" {...settingsMedia}>
                        {media}
                    </Slider>

                    {postDescription}
                </div>
            </div>

            <div className="post-navigation">
                <button type="button" className="btn-nav" onClick={history.goBack}>Back</button>
                <Link to={nextUrl} className="btn-nav" data-disabled={!loadData.data?.end.nextUid}>Next</Link>
            </div>
        </article>
    );
}

export default ENDDetailContainer;
